import { pageOf, updateSchema } from "@shared/contracts";
import { request } from "../../platform/api/request";

const updatePageSchema = pageOf(updateSchema);

export function fetchUpdates(cursor: string | null, signal: AbortSignal) {
  const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
  return request(`/updates${query}`, updatePageSchema, { signal });
}
